import { createAsyncThunk } from "@reduxjs/toolkit";
import { UsersAPI } from "api/api/usersApi/usersApi";
import axios from "axios";
import { PutUsersAsAdminBody, PutUsersAsAdminResponse } from "api/api/usersApi/types";

export const putUsersAsAdmin = createAsyncThunk<
  PutUsersAsAdminResponse,
  PutUsersAsAdminBody
>(
  "users/putUsersAsAdmin",
  async (body, { rejectWithValue }) => {
    try {
      const response = await UsersAPI.putUsers(body);
      return response.data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error("Error while updating user details as admin", error.response?.data);
        return rejectWithValue(error.response?.data || "Unknown error");
      }
      else {
        console.error("Error while updating user details as admin", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  })